import React, { useEffect, useState } from 'react';
import goals2 from "../../../../assets/shapes_svg/output/goals2.svg";
import social2 from '../../../../assets/shapes_svg/output/social2.svg';
import { getHighlight } from '../../../../apis/Ambition';
import { useRef } from 'react';
import { PRINT_WIDTH } from '..';
import { fontReport } from '../../../../apis/util';

export const ActiveParticipation = () => {
  const [text1, setText1] = useState();
  const [text2, setText2] = useState();
  const [text3, setText3] = useState();
  const [text4, setText4] = useState();
  const [text5, setText5] = useState();

  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = () => {
    getHighlight({ key: "wasteinitiative", setValue: setText1 });
    getHighlight({ key: "circularinitiative", setValue: setText2 });
    getHighlight({ key: "virgininitiative", setValue: setText3 });
    getHighlight({ key: "regenerateinitiative", setValue: setText4 });
    getHighlight({ key: "wildlifeinitiative", setValue: setText5 });
  };

  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);

  return (
    <div className="ourenvironmentalaim" ref={ref}>
      <div className="ourenvironmentalaim__title">
        <h4 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.7/PRINT_WIDTH,"rem") }}>Active Participation</h4>
        <img src={social2} alt="" />
      </div>
      <div className="environmentalaim__body ">
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.4/PRINT_WIDTH,"rem") }}>{text1 + "\n\n" + text2 + "\n\n" + text3 + "\n\n" + text4 + "\n\n" + text5}</h5>
      </div>
    </div>
  );
};
export const OurEnvironmentalAim = ({ title = <>Our <b>Environmental</b> Aim</>, img = goals2, keyHighlight }) => {
  const [text, setText] = useState();
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = () => {
    getHighlight({
      key: keyHighlight,
      setValue: setText
    });
  };

  return (
    <div className="ourenvironmentalaim" ref={ref}>
      <div className="ourenvironmentalaim__title" >
        <h4 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.7/PRINT_WIDTH,"rem") }}>{title}</h4>
        <img src={img} alt="" />
      </div>
      <div className="environmentalaim__body ">
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,1.4/PRINT_WIDTH,"rem") }}>{text}</h5>
        {/* <h5>{
              !text ?
              `Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum error soluta provident nemo perspiciatis voluptatum facilis quia quod, quibusdam suscipit alias excepturi rem culpa numquam delectus, fuga illo. Et, animi!
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum error soluta provident nemo perspiciatis voluptatum facilis quia quod, quibusdam suscipit alias excepturi rem culpa numquam delectus, fuga illo. Et, animi!
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum error soluta provident nemo perspiciatis voluptatum facilis quia quod, quibusdam suscipit alias excepturi rem culpa numquam delectus, fuga illo. Et, animi!
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum error soluta provident nemo perspiciatis voluptatum facilis quia quod, quibusdam suscipit alias excepturi rem culpa numquam delectus, fuga illo. Et, animi!
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum error soluta provident nemo perspiciatis voluptatum facilis quia quod, quibusdam suscipit alias excepturi rem culpa numquam delectus, fuga illo. Et, animi!
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum error soluta provident nemo perspiciatis voluptatum facilis quia quod, quibusdam suscipit alias excepturi rem culpa numquam delectus, fuga illo. Et, animi!
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum error soluta provident nemo perspiciatis voluptatum facilis quia quod, quibusdam suscipit alias excepturi rem culpa numquam delectus, fuga illo. Et, animi!
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum error soluta provident nemo perspiciatis voluptatum facilis quia quod, quibusdam suscipit alias excepturi rem culpa numquam delectus, fuga illo. Et, animi!
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum error soluta provident nemo perspiciatis voluptatum facilis quia quod, quibusdam suscipit alias excepturi rem culpa numquam delectus, fuga illo. Et, animi!
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum error soluta provident nemo perspiciatis voluptatum facilis quia quod, quibusdam suscipit alias excepturi rem culpa numquam delectus, fuga illo. Et, animi!
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum error soluta provident nemo perspiciatis voluptatum facilis quia quod, quibusdam suscipit alias excepturi rem culpa numquam delectus, fuga illo. Et, animi!`
            :""
            }
            </h5> */}
      </div>
      {/* <img src={bubble6} alt="" /> */}
    </div>
  );
};
